import InboundCallIcon from 'components/icons/inboundCall';
import OutboundCallIcon from 'components/icons/outboundCall';
import { CellWrapper } from '../styled';

interface Props {
    value?: 'inbound' | 'outbound';
}

const DirectionColumn = ({ value }: Props) => (
    <CellWrapper>
        {value === 'inbound' ? <InboundCallIcon /> : <OutboundCallIcon />}
    </CellWrapper>
);

export default DirectionColumn;
